import { capitalizeFirstLetter } from './formatText';

// Format date to a readable string
export function formatDate(dateString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
}

// Parse YYYYMMDD til Date-objekt
export const dateFromYyyymmdd = yyyymmdd => {
    const s = String(yyyymmdd || '');
    if (!/^\d{8}$/.test(s)) return null;

    const y = Number(s.slice(0, 4));
    const m = Number(s.slice(4, 6)) - 1;
    const d = Number(s.slice(6, 8));

    return new Date(y, m, d);
};

// Parse YYYYMMDD til lesbar dag-label på norsk
export const formatDayLabel = yyyymmdd => {
    const dt = dateFromYyyymmdd(yyyymmdd);
    if (!dt) return String(yyyymmdd || '');

    const weekday = new Intl.DateTimeFormat('nb-NO', { weekday: 'long' }).format(dt);
    const date = new Intl.DateTimeFormat('nb-NO', { day: 'numeric', month: 'long' }).format(dt);

    return `${capitalizeFirstLetter(weekday)} ${date}`;
};

// Hent dagens dato som YYYYMMDD (lokal tid)
export function getTodayYyyymmddLocal() {
    const dt = new Date();
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, '0');
    const d = String(dt.getDate()).padStart(2, '0');
    return Number(`${y}${m}${d}`);
}
